module.exports = __webpack_public_path__ + "media/images/project/reward/r5000-07906b14d319391060540d8389cfba9c.jpg";